import { InjectionToken } from '@angular/core';

import type { RegisteredSettings } from '@mp/kernel/settings/data-access';

export const ORGANIZATION_SETTINGS_TOKEN = new InjectionToken<RegisteredSettings[]>('OrganizationSettings');
